import { MARKETPLACE_INVENTORY_PUSH_PROVIDERS } from "@redotech/redo-inventory-common/provider/marketplace-inventory-push";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const enableIms = {
  name: "enableIms" as const,
  input: z.object({
    teamId: zExt.objectId(),
    /** Import starting on-hand from this channel; none keeps what's in Redo. */
    importFrom: z.enum(MARKETPLACE_INVENTORY_PUSH_PROVIDERS).nullish(),
  }),
  output: z.object({ success: z.boolean(), workflowId: z.string() }),
};
